function LottieContainer() {
  return (
    <div className=" flex justify-center flex-col w-full h-full relative">
      <div
        id="animationWindow"
        className=" flex justify-start items-center w-full h-full"
      ></div>
    </div>
  );
}

export default LottieContainer;
